export { default } from './ChatProductMessages';